<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="evaluateForm" (change)="evaluateChange()" (submit)="evaluateSubmit()">
        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"EVALUATION_TITLE" | translate | titlecase}}</h6>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row justify-content-center">
                            <!-- <h5 class="font-bold m-0">{{(globals.lang == 'en')? candNameEn:candNameAr}} - {{candCode}} -
                                {{candNatId}}</h5> -->
                            <div class="img-with-text">
                                <!-- <img src="assets/images/stud-image.png" class="img-fluid" width="100" id="userImageTag"> -->
                                <img src="{{ photoPath}}" onerror="this.src ='assets/images/stud-image.png';"
                                    alt="Photo" class="img-fluid" width="100" id="userImageTag">
                                <p style="font-weight: bold;font-size: 16px">
                                    {{"CANDIDATE_NAME" | translate | titlecase}}: &nbsp; &nbsp;{{((globals.lang ==
                                    'en')? candNameEn:candNameAr)}} <br /><br />
                                    {{"CANDUDATE_CODE" | translate | titlecase}}: &nbsp; &nbsp; {{ candCode}}
                                    <br /><br />
                                    {{"NATIONAL_ID" | translate | titlecase}}: &nbsp; &nbsp;{{ candNatId}}<br /><br />
                                </p>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-md-8 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EVALUATION_DATE" | translate | titlecase}}</label>
                                <input type="text" class="form-control" value="" formControlName="evaluateDate"
                                    readonly>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EVALUATION_STATUS" | translate | titlecase}}</label>
                                <select class="form-control custom-select" formControlName="evaluateStatus"
                                    [attr.disabled]="true">
                                    <option value="" [selected]="true">{{"SELECT" | translate | titlecase}}</option>
                                    <option value="Accepted">{{"ACCEPT" | translate | titlecase}}</option>
                                    <option value="Rejected">{{"REJECT" | translate | titlecase}}</option>
                                    <option value="Accommodates/Acceptance">
                                        {{"ACCOMODATES_ACCEPTANCE" | translate | titlecase}}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="evaluateForm.controls.evaluateStatus.touched && evaluateForm.controls.evaluateStatus.invalid && evaluateForm.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EVALUATION_COMMENT" | translate | titlecase}}</label>
                                <input type="text" class="form-control"
                                    placeholder="{{'EVALUATION_COMMENT' | translate | titlecase}}"
                                    formControlName="evaluateComment">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="evaluateForm.controls.evaluateComment.touched && evaluateForm.controls.evaluateComment.invalid && evaluateForm.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 d-flex flex-wrap justify-content-center justify-content-lg-end">
                                <!-- <button type="button" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/">
                                    Cancel</button> -->
                                <button type="submit" class="btn btn-primary m-2 rounded-0"
                                    (click)="changeAcceptanceStatus('Accepted')"
                                    *ngIf="!creating && globals.checkUserHasPermission('CANDIDATE_INQUIRY - EVALUATION-UPDATE')"><i
                                        class="fas fa"></i>
                                    {{"ACCEPT" | translate | titlecase}}</button>
                                <button type="submit" class="btn btn-primary m-2 rounded-0"
                                    (click)="changeAcceptanceStatus('Rejected')"
                                    *ngIf="!creating && globals.checkUserHasPermission('CANDIDATE_INQUIRY - EVALUATION-UPDATE')"><i
                                        class="fas fa"></i>
                                    {{"REJECT" | translate | titlecase}}</button>
                                <button type="submit" class="btn btn-primary m-2 rounded-0"
                                    (click)="changeAcceptanceStatus('Accommodates/Acceptance')"
                                    *ngIf="!creating && globals.checkUserHasPermission('CANDIDATE_INQUIRY - EVALUATION-UPDATE')"><i
                                        class="fas fa"></i>
                                    {{"ACCOMODATES_ACCEPTANCE" | translate | titlecase}}</button>
                                <app-loader [show]="creating"></app-loader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<app-loader [attr.show]="showLoader"></app-loader>